import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Coders, protect your hands; you won't like coding without em",
  "description": "",
  "published": "2019-06-24T00:00:00.000Z",
  "redirect_from": ["/blog/coders-protect-your-hands-you-wont-like-coding-without-em/swizec/9133"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/bec2503facdfdd4ab8b1501006627b83/WPv7buU.gif",
        "alt": null
      }}></img></p>
    <p>{`Wednesday my hands were very sore tried dictation to write my code then I put my hands on break.`}</p>
    <p>{`No seriously, that sucked.`}</p>
    <p>{`You can see the `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=RfGKIZOZPRY"
      }}>{`full video here`}</a>{` 👇 took me 30 minutes to write 8 lines of code, a React adder component.`}</p>
    <lite-youtube {...{
      "videoid": "RfGKIZOZPRY",
      "videostartat": "0"
    }}></lite-youtube>
    <h2 {...{
      "id": "whats-it-like-to-write-code-with-your-voice"
    }}>{`What's it like to write code with your voice`}</h2>
    <p>{`Move left, move left, move left, move left, delete that, delete that, move left, function, undo, undo, delete that, move left, move left, undo, agh damn it why did you write that, crap, undo, undo, undo, ok, no wait, uaaaaa`}</p>
    <p>{`Like that.`}</p>
    <p>{`I learned that I curse under my breath when things go wrong. When your computer is listening and types out everything you say ... 😅`}</p>
    <p>{`With MacOS Dictation you press command twice and off you go in voice control mode. Anything you say, the computer tries to translate into written text.`}</p>
    <p>{`So easy to forget to turn it off. Especially when you mumble or you mispronounce something, the computer gets confused and goes down a weird rabbit hole.`}</p>
    <p>{`You then have to stop dictation and reset from scratch. This happens a lot.`}</p>
    <p>{`Dictating text worked well. Code and voice commands ... urgh.`}</p>
    <p>{`MacOS Advanced Dictation gives you a bunch of special commands. Like move left, delete that, capitalize that, move to end of word, etc.`}</p>
    <p><img parentName="p" {...{
        "src": "/7d8d1c9af2c763b7ba5dc4983a24ad54/0DJ7T9x.gif",
        "alt": null
      }}></img></p>
    <p>{`All great in theory, but half the time my computer would type out the command instead of doing the thing. Replacing uppercase letters with lowercase was a constant chore.`}</p>
    <p>{`Say you want to write `}<inlineCode parentName="p">{`function`}</inlineCode>{`, here's how you do it 👇`}</p>
    <pre><code parentName="pre" {...{}}>{`🗣 *function*
Function |

🗣 *move left*
Functio|n

🗣 *move left*
Functi|on

🗣 *move left*
Funct|ion

🗣 *move left*
Func|tion

🗣 *move left*
Fun|ction

🗣 *move left*
Fu|nction

🗣 *move left*
F|unction

🗣 *delete that*
|unction

🗣 *lowercase f*
f|unction
`}</code></pre>
    <p>{`🙃`}</p>
    <p>{`Imagine your hands break down and that's your life for a few weeks or months? Oof.`}</p>
    <p>{`You'd get better at it, find other software than built-in dictation, but still ... we take our keyboards and impressive typing speeds for granted don't we?`}</p>
    <p>{`Gotta be careful with that.`}</p>
    <p>{`Keyboards will wreck your hands. That warning label on the back saying `}<em parentName="p">{`"Prolonged use of this device can cause serious injury"`}</em>{` is not joking around.`}</p>
    <h2 {...{
      "id": "but-why-cant-voice-do-code"
    }}>{`But why can't voice do code?`}</h2>
    <p>{`If voice works so well for Alexa and dictating text messages, why not for writing code?`}</p>
    <p>{`It's all got to do with how `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Speech_recognition"
      }}>{`speech recognition`}</a>{` works.`}</p>
    <p>{`Speech recognition is a tough fuzzy computational problem. Everything from signals processing to machine learning has to work just right.`}</p>
    <p>{`In a nutshell (because I'm no expert) 👇`}</p>
    <ol>
      <li parentName="ol">{`Listen to a microphone`}</li>
      <li parentName="ol">{`Find the human voice`}</li>
      <li parentName="ol">{`Filter out noise`}</li>
      <li parentName="ol">{`Filter out irrelevant background humans`}</li>
      <li parentName="ol">{`Tokenize human voice into words `}<em parentName="li">{`(this is based on trained machine learning models using many different dialects and accents)`}</em></li>
      <li parentName="ol">{`Decide how well you recognized individual words`}</li>
      <li parentName="ol">{`Feed certainty weighted words into a statistical model, often a `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Hidden_Markov_model"
        }}>{`hidden markov model`}</a>{` `}<em parentName="li">{`(more trained machine learning models)`}</em></li>
      <li parentName="ol">{`Use statistics to fill in the blanks`}</li>
      <li parentName="ol">{`Try a few options to get the likeliest sequence`}</li>
      <li parentName="ol">{`Turn result back into text`}</li>
    </ol>
    <p>{`Lots of fuzziness and statistics. Each step of the way, something can go wrong. And it does.`}</p>
    <p>{`Computer can misunderstand a word, mishear something, you might pronounce it weird, or there might just be too much noise. Computer fills in the blanks with an educated guess.`}</p>
    <p>{`Sometimes as you keep talking, you change the meaning and the computer realizes it made a mistake. Goes back to fix the word so it makes more sense.`}</p>
    <p>{`You can see this working beautifully when dictating text messages. It's gotten so good I `}<em parentName="p">{`prefer`}</em>{` to dictate my texts when I'm on the go. Much easier than the iOS keyboard 😇`}</p>
    <h3 {...{
      "id": "you-recognize-speech-the-same-way"
    }}>{`You recognize speech the same way`}</h3>
    <p>{`You do this all the time inside your brain.`}</p>
    <p>{`Ever noticed how it's easier to understand a good friend at a noisy bar than it is a stranger? Or how difficult bar conversation becomes when you're with non-native speakers?`}</p>
    <p>{`That's because you're better at guessing what your friend says than a stranger. And your foreign friends have accents that are harder to filter out from the noise so there's more guessing.`}</p>
    <p>{`Or vice-versa if you're the foreigner.`}</p>
    <p>{`Very hard to chat in a loud bar coz you can't follow what's going on. Or at least I can't ...`}</p>
    <h2 {...{
      "id": "so-why-not-code"
    }}>{`So why not code?`}</h2>
    <p>{`With deep learning and big data, speech recognition has become really good for prose. Amazing even. If I didn't type at 120wpm on my keyboard, I'd be dictating this article right now.`}</p>
    <p>{`I already speak into my phone, for texting, almost as often as I type. It's easier.`}</p>
    <p>{`So why not code?`}</p>
    <p>{`It's all got to do with steps 7 and 8 in our list. You are speaking in symbols and indentation and weird words in weird sequences.`}</p>
    <pre><code parentName="pre" {...{}}>{`🗣 *use state*
`}</code></pre>
    <p>{`What is that? Is it `}<inlineCode parentName="p">{`Use state`}</inlineCode>{` or `}<inlineCode parentName="p">{`UseState`}</inlineCode>{` or `}<inlineCode parentName="p">{`useState`}</inlineCode>{`? How is a computer supposed to know?`}</p>
    <p>{`Based on all its data, all the training sets, `}<inlineCode parentName="p">{`Use state`}</inlineCode>{` is its best bet. You are likely starting a new sentence. It's a weird sentence, but the computer don't judge.`}</p>
    <p>{`To get `}<inlineCode parentName="p">{`useState`}</inlineCode>{`, the computer would have to understand your code. It would need to know you are writing a React Hook, not just a code comment.`}</p>
    <p>{`But it can't. It doesn't have the context. And even if it did, you'd still need a model trained specifically on React code. And a model trained on JavaScript. And a model for Vue. And another for C/C++. And one for ...`}</p>
    <p>{`You get the picture 👉 you need a new trained statistical model for every language you want to dictate.`}</p>
    <p>{`Works great for English. Might take a while for all these weirdo esoteric programming languages we like to use. I wouldn't hold my breath 😅`}</p>
    <h2 {...{
      "id": "what-do"
    }}>{`What do?`}</h2>
    <p>{`So what can you do to avoid this right now?`}</p>
    <p>{`Invest in a good keyboard, get a good mouse, learn how to relax your hands, type without moving or bending your wrists too much. Do it now before it's too late.`}</p>
    <p>{`You won't like coding with your voice.`}</p>
    <p>{`Happy Monday,`}</p>
    <p>{`~Swizec`}</p>
    <p>{`PS: before you ask, I like the Truly Ergonomic keyboard and a good Logitech mouse. Apple has the worst least ergonomic input devices. Make sure your forearms are at a comfortable angle to your keyboard, do not try to keep them perpendicular. Yes even on a laptop keyboard. Plop your mouse hand on the mouse like a dead fish. Do not grab. Try to move with your forearm, not your wrist or fingers.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      